// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2A50c","colMin":"styles_colMin__17Qle"};